import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';

import { GetClientBillingReportQuery, GetClientBillingReportInput, ClientBillingReportPayload } from '../gql-types.generated';

const QUERY_CLIENT_BILLING_REPORT = gql`
query getClientBillingReport($input: GetClientBillingReportInput!) {
    clientBillingReport(input: $input) {
        message
        errors {
            code
            message
        }
        result
        csvBase64String
    }
  }
`;

export const queryClientBillingReport = async (
  client: ApolloClient<NormalizedCacheObject>,
  input: GetClientBillingReportInput
): Promise<ClientBillingReportPayload> => {
  const { clientId, month, year, reportType } = input;
  const { data, errors } = await client.query<GetClientBillingReportQuery>({
    variables: {
      input: {
        clientId,
        month,
        year,
        reportType
      }
    },
    query: QUERY_CLIENT_BILLING_REPORT,
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the user.
    throw new Error('An error has occurred during the query.');
  }

  return data?.clientBillingReport as ClientBillingReportPayload;
};